import React from 'react'
import BotSimpleMessage from './BotSimpleMessage'
import BotTextInput from './BoxTextInput'
import AddressAutocomplete from './AddressAutocomplete'
import SingleSelectionMessage from './SingleSelectionMessage'
import InnerFormMin from './InnerFormMin'
import InnerSearchResultFibra from './InnerSearchResultFibra'
import InnerSearchResultLuce from './InnerSearchResultLuce'
import InnerSearchResultLuceGas from './InnerSearchResultLuceGas'
import InnerSearchResultGas from './InnerSearchResultGas'
import ChatComponent from './ChatComponent'

export default function Message({ message,
    isLastBotMessage,
    setIsTyping,
    messages,
    setMessages,
    answers,
    setAnswers, urlBotImage
}) {



    if (message.tipo === "messaggio")
        return (
            <BotSimpleMessage message={message}
                isLastBotMessage={isLastBotMessage}
                setIsTyping={setIsTyping}
                messages={messages}
                setMessages={setMessages}
                urlBotImage={urlBotImage} 
                />
        )

    if (message.tipo === "selezione_singola")
        return (
            <SingleSelectionMessage message={message}
                isLastBotMessage={isLastBotMessage}
                setIsTyping={setIsTyping}
                messages={messages}
                setMessages={setMessages}
                answers={answers}
                setAnswers={setAnswers}
                urlBotImage={urlBotImage}
            />
        )

    if (message.tipo === "input_testo")
        return (
            <BotTextInput message={message}
                isLastBotMessage={isLastBotMessage}
                setIsTyping={setIsTyping}
                messages={messages}
                setMessages={setMessages}
                answers={answers}
                setAnswers={setAnswers}
                urlBotImage={urlBotImage}
            />
        )

        if (message.tipo === "input_indirizzo")
            return (
                <BotTextInput message={message}
                    isLastBotMessage={isLastBotMessage}
                    setIsTyping={setIsTyping}
                    messages={messages}
                    setMessages={setMessages}
                    answers={answers}
                    setAnswers={setAnswers}
                    urlBotImage={urlBotImage}
                    isAddressField={true}
                />
            )

		if (message.tipo === "input_testo_address")
				return (
					<AddressAutocomplete message={message}
						isLastBotMessage={isLastBotMessage}
						setIsTyping={setIsTyping}
						messages={messages}
						setMessages={setMessages}
						answers={answers}
						setAnswers={setAnswers}
						urlBotImage={urlBotImage}
					/>
				)


    if (message.tipo === "formMin")
        return (
            <InnerFormMin 
                message={message}
                isLastBotMessage={isLastBotMessage}
                setIsTyping={setIsTyping}
                messages={messages}
                setMessages={setMessages}
                answers={answers}
                setAnswers={setAnswers}
                urlBotImage={urlBotImage}
            />
        )



    if (message.tipo === "risultati_ricerca_fibra")
        return (
            <InnerSearchResultFibra
                message={message}
                isLastBotMessage={isLastBotMessage}
                setIsTyping={setIsTyping}
                messages={messages}
                setMessages={setMessages}
                answers={answers}
                setAnswers={setAnswers}
                urlBotImage={urlBotImage}
            />
        )

        
    if (message.tipo === "risultati_ricerca_luce")
        return (
            <InnerSearchResultLuce
                message={message}
                isLastBotMessage={isLastBotMessage}
                setIsTyping={setIsTyping}
                messages={messages}
                setMessages={setMessages}
                answers={answers}
                setAnswers={setAnswers}
                urlBotImage={urlBotImage}
            />
        )

        if (message.tipo === "risultati_ricerca_gas")
            return (
                <InnerSearchResultGas
                    message={message}
                    isLastBotMessage={isLastBotMessage}
                    setIsTyping={setIsTyping}
                    messages={messages}
                    setMessages={setMessages}
                    answers={answers}
                    setAnswers={setAnswers}
                    urlBotImage={urlBotImage}
                />
            )    

            if (message.tipo === "risultati_ricerca_luce_gas")
                return (
                    <InnerSearchResultLuceGas
                        message={message}
                        isLastBotMessage={isLastBotMessage}
                        setIsTyping={setIsTyping}
                        messages={messages}
                        setMessages={setMessages}
                        answers={answers}
                        setAnswers={setAnswers}
                        urlBotImage={urlBotImage}
                    />
                )      

    if (message.tipo === "chat")
        return (
            <ChatComponent
                message={message}
                isLastBotMessage={isLastBotMessage}
                setIsTyping={setIsTyping}
                messages={messages}
                setMessages={setMessages}
                answers={answers}
                setAnswers={setAnswers}
                urlBotImage={urlBotImage}
            />
        )

}
